export const FACEBOOK_BUTTON_CONTINUE = "Continue with Facebook";
export const FACEBOOK_BUTTON_SIGN_UP = "Sign Up with Facebook";
export const FACEBOOK_BUTTON_DISCONNECT = "Disconnect Facebook Account";
export const FACEBOOK_BUTTON_CONNECT = "Connect Facebook Account";
